import { Link } from "react-router-dom";
import { FileSize, KeyValueList, NoData } from "../../../../../components";
import { stripFileType } from "../../../../../utils";
import { getSearchPivotLink } from "../../../util";
import styles from "./info.module.scss";

type Props = {
  fileType?: string;
  fileFormat?: string;
  fileSize?: number | string;
};

const Info = ({ fileFormat, fileSize, fileType }: Props) => {
  const fileTypeSearch = stripFileType(fileType);
  const fileFormatSearch = fileFormat?.split(":")[0];

  return (
    <KeyValueList className={styles.info}>
      <KeyValueList.Item
        label="File Type: "
        value={
          fileType ? (
            <Link
              className={styles.info_link}
              title="Look up on Search"
              to={getSearchPivotLink(`filetype:"${fileTypeSearch}"`)}
              data-testid="report_summary_file_type_link"
            >
              {fileType}
            </Link>
          ) : (
            <NoData />
          )
        }
        data-testid="report_summary_info_file_type"
      />
      <KeyValueList.Item
        label="File Format: "
        value={
          fileFormat ? (
            <Link
              className={styles.info_link}
              title="Look up on Search"
              to={getSearchPivotLink(
                `filetype:"${fileTypeSearch}/${fileFormatSearch}"`
              )}
              data-testid="report_summary_info_file_format_link"
            >
              {fileFormat}
            </Link>
          ) : (
            <NoData />
          )
        }
        data-testid="report_summary_info_file_format"
      />
      <KeyValueList.Item
        label="Size: "
        value={
          fileSize ? (
            <Link
              className={styles.info_link}
              title="Look up on Search"
              to={getSearchPivotLink(`size:${fileSize}`)}
              data-testid="report_summary_info_file_format_link"
            >
              <FileSize value={fileSize} showBytes />
            </Link>
          ) : (
            <NoData />
          )
        }
        data-testid="report_summary_info_file_size"
      />
    </KeyValueList>
  );
};
export default Info;
